import React, { useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { FilePdf, FilmStrip, CircleNotch, ArrowSquareOut } from "@phosphor-icons/react";

const DOCS = [
  { key: "techdoc", type: "application/pdf", Icon: FilePdf, title: "Documentación funcional y técnica", btn: "Abrir PDF",
    desc: "Arquitectura, roles, módulos, integraciones, seguridad, operación y registro de cambios." },
  { key: "video", type: "video/mp4", Icon: FilmStrip, title: "Video ejecutivo (5:24)", btn: "Ver video",
    desc: "El reto, la plataforma y una semana con Carlos: vehículo nuevo, mantenimiento y piezas por WhatsApp, encuesta CSAT, Instagram y Messenger con perfil unificado y la comparación con un bot simple." },
];

function DocCard({ doc }) {
  const [busy, setBusy] = useState(false);
  const open = async () => {
    const win = window.open("", "_blank");
    setBusy(true);
    try {
      const { data } = await api.get(`/docs/${doc.key}`, { responseType: "blob" });
      win.location.href = URL.createObjectURL(new Blob([data], { type: doc.type }));
    } catch {
      win?.close();
      toast.error("No se pudo abrir el documento");
    } finally { setBusy(false); }
  };
  return (
    <div className="rounded-lg border border-border bg-card p-5" data-testid={`doc-card-${doc.key}`}>
      <div className="flex items-start gap-4">
        <div className="w-11 h-11 rounded-xl bg-accent flex items-center justify-center shrink-0">
          <doc.Icon size={22} weight="duotone" className="text-accent-foreground" />
        </div>
        <div className="flex-1">
          <div className="font-heading font-bold">{doc.title}</div>
          <p className="text-sm text-muted-foreground mt-1">{doc.desc} Solo visible para administradores.</p>
          <Button onClick={open} disabled={busy} className="mt-4 gap-2" data-testid={`open-${doc.key}-btn`}>
            {busy ? <CircleNotch size={16} className="animate-spin" /> : <ArrowSquareOut size={16} />} {doc.btn}
          </Button>
        </div>
      </div>
    </div>
  );
}

export default function DocsSection() {
  return (
    <div className="space-y-4 max-w-2xl" data-testid="section-docs">
      {DOCS.map((d) => <DocCard key={d.key} doc={d} />)}
    </div>
  );
}
